const SENSITIVE_QUERY_PARAMS =
  /([?&](?:token|code|otp|email|phone|password|access_token|refresh_token|query|search|referralCode)=)[^&#\s]*/gi;
const CLICK_ID_PARAMS =
  /([?&](?:fbclid|gclid|gbraid|wbraid|msclkid|ttclid|twclid|igshid|dclid|yclid|li_fat_id|epik|rdt_cid|_gl)=)[^&#\s]*/gi;
// The same ids URL-encoded inside another param, e.g. `/login?redirect=%2Fdeal%3Ffbclid%3D…`.
const ENCODED_CLICK_ID_PARAMS =
  /((?:%3F|%26)(?:fbclid|gclid|gbraid|wbraid|msclkid|ttclid|twclid|igshid|dclid|yclid|li_fat_id|epik|rdt_cid|_gl)%3D)[^&#\s%]*/gi;
const EMAIL_PATTERN =
  /[A-Za-z0-9._%+-]+(?:@|%40)[A-Za-z0-9.-]+\.[A-Za-z]{2,}/gi;
const JWT_PATTERN = /eyJ[A-Za-z0-9_-]{10,}/g;

export function scrubPii(value: string): string {
  return value
    .replace(SENSITIVE_QUERY_PARAMS, '$1[redacted]')
    .replace(CLICK_ID_PARAMS, '$1[redacted]')
    .replace(ENCODED_CLICK_ID_PARAMS, '$1[redacted]')
    .replace(EMAIL_PATTERN, '[email]')
    .replace(JWT_PATTERN, '[token]');
}

const URL_PROPERTY_KEYS = [
  '$current_url',
  '$pathname',
  '$referrer',
  '$prev_pageview_pathname',
  '$prev_pageview_url',
  'previous_url',
  '$initial_current_url',
  '$initial_pathname',
  '$initial_referrer',
  '$session_entry_url',
  '$session_entry_pathname',
  '$session_entry_referrer'
] as const;

type PropertyBag = Record<string, unknown>;

const scrubUrlKeys = (bag: PropertyBag | undefined) => {
  if (!bag || typeof bag !== 'object') return;
  for (const key of URL_PROPERTY_KEYS) {
    const value = bag[key];
    if (typeof value === 'string') bag[key] = scrubPii(value);
  }
};

export function scrubAnalyticsEventUrls<
  T extends {
    properties?: PropertyBag;
    $set?: PropertyBag;
    $set_once?: PropertyBag;
  }
>(event: T): T {
  const properties = event.properties;
  scrubUrlKeys(properties);
  scrubUrlKeys(properties?.$set as PropertyBag | undefined);
  scrubUrlKeys(properties?.$set_once as PropertyBag | undefined);
  scrubUrlKeys(event.$set);
  scrubUrlKeys(event.$set_once);
  return event;
}
